const policyDataReducer = (state = {}, action) => {
    switch (action.type) {
        case 'UPDATE_POLICY_DATA':
            return {
                ...state,
                ...action.data
            };
        default:
            return state;
    }
};

export default policyDataReducer;